<template>
      
      <!-- Begin page -->
      <div id="wrapper">
            
            <!-- Top Bar Start -->
            <topbar></topbar>
            <!-- Top Bar End -->
            
            
            <!-- ========== Left Sidebar Start ========== -->
            
            <!-- Left Sidebar End -->
            <left></left>
            
            
            <!-- ============================================================== -->
            <!-- Start right Content here -->
            <!-- ============================================================== -->
            <div class="content-page">
                  <!-- Start content -->
                  <div class="content">
                        <div class="container-fluid">
                        
                              <div class="row">
                                    <div class="col-12">
                                          <div class="page-title-box">
                                                <h4 class="page-title float-left">考试专区</h4>
                                                <ol class="breadcrumb float-right">
                                                      <li class="breadcrumb-item"><a href="#">cpwm</a></li>
                                                      <li class="breadcrumb-item"><a href="#">考试专区</a></li>
                                                      <li class="breadcrumb-item active">考试报名</li>
                                                </ol>
                                          
                                                <div class="clearfix"></div>
                                          </div>
                                    </div>
                              </div>
                              <!-- end row -->
                        
                        
                              <div class="row">
                                    <div class="col-md-12">
                                          <div class="card-box">
                                                <div class="row">
                                                      <div class="col-12">
                                                            
                                                      
                                                            <h1 class="display-1">付费成功</h1>
                                                            <p class="text-muted">恭喜您，已经成功付费，快快预约考试吧！</p>
                                                      
                                                            <div class="clearfix"></div>
                                                      
                                                           
                                                      </div>
                                          
                                                </div>
                                          
                                          
                                                <!-- end row -->
                                    
                                          </div>
                                    </div>
                        
                              </div>
                              <!-- end row -->
                  
                  
                        </div> <!-- container -->
            
                  </div> <!-- content -->
      
                  <!--footer-->
      
            </div>
            
            
            <!-- ============================================================== -->
            <!-- End Right content here -->
            <!-- ============================================================== -->
      
      
      </div>
      <!-- END wrapper -->


</template>

<script>
      import topbar from './topbar';
      import left from './left';
      export default {
            name: 'main',
            components:{topbar,left},
            created() {
                  this.$router.push({name:'signup'});
                  
            }
            //mounted over


      }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
      .zx{width:100%;}
      .zx li{width:100%;float: left}

  
     
</style>



// WEBPACK FOOTER //
// src/components/signup_success.vue